import { LiveStreamAction } from './live-stream.action';

export class LiveStreamState {
    /**
     * Informação da Live no YouTube
     */
    public live: any;
}

export const initialState: LiveStreamState = {
    live: null,
};

export function LiveStreamReducer(
    state: LiveStreamState = initialState,
    action?: LiveStreamAction,
): LiveStreamState {

    switch (action.type) {

        case LiveStreamAction.getLive:
            return {
                ...state,
                ...{ pending: true, payload: action.payload },
            };
        case LiveStreamAction.getLiveError:
            return { ...state, ...{ error: action.payload } };
        case LiveStreamAction.getLiveSuccess:
            return { ...state, ...{ live: action.payload } };

        default:
            return state;
    }
}
